/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Communiqués de presse - CamAPS FX',
    titleMeta: 'Communiqués de presse - CamAPS FX',
    descriptionMeta: 'Derniers communiqués de presse et actualités de CamAPS FX.',
    keywords: 'communiqués de presse camaps, actualités camaps, actualités technologie diabète',
    localeMeta: 'fr_fr',

    bannerTitle: 'Communiqués de presse',
    bannerSubtitle: 'Restez informé de nos dernières annonces',

    contactText: 'Pour toute demande de presse, veuillez contacter via <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Tous les communiqués de presse sont publiés en anglais.',

    download: 'Télécharger',
    showMore: 'Afficher plus',
    showLess: 'Afficher moins',
};

